<template>
	<v-dialog persistent @click:outside="closeDialog()" v-model="dialog" max-width="700" content-class="test-class">
		<v-card >
			<v-card-title>
				Dodaj załączniki
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="py-3">
				<div v-if="!files.length" class="drop-area text-center relative">
					<div class="file-input">
						<input :accept="types" ref="input" :key="key" type="file" multiple id="attach-video__file-input" class="fileinput" @change="selectFiles" @input="selectFiles"/>
					</div>

					<label class="my-5 v-btn v-btn--has-bg theme--light elevation-0 v-size--x-large accent" for="attach-video__file-input">
						Wybierz pliki z dysku
					</label>
					<div class="font-16 bold">
						albo przeciągnij je tutaj
					</div>
					<div class="mt-3 text-accent font-14">
						Maksymalny rozmiar pliku wynosi {{ fileValidation.size }}MB
						<div class="mt-2">
							Dozwolone typy plików: {{ types }}
						</div>
					</div>
				</div>
			</v-card-text>
			<v-card-actions class="justify-content-center py-7">
				<v-btn color="light" elevation="0" @click="closeDialog()">Anuluj</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
	data() {
		return {
			dialog: false,
			files: [],
			key: 0
		}
	},
	computed: {
		...mapGetters({
			fileValidation: 'validation/attachments'
		}),

		types() {
			return this.fileValidation.types.join(", ");
		},
		maxMB() {
			return this.fileValidation.size * 1024 * 1024;
		}
	},
	methods: {
		selectFiles(e) {
			console.log("SELECT FILES", e)
			let files = Array.from(e.target.files);
			let failedFiles = [];
			let failedText = '';
			files.forEach(file => {
				if(file.size <= this.maxMB) {
					this.files.push(file);
				}
				else {
					failedFiles.push(file);
					if(failedFiles.length  > 1) {
						failedText += '<br>';
					}
					failedText += `Plik ${file.name} jest za duży`;
				}
			});
			if(this.files.length == 0 && failedFiles.length) {
				this.$toast.error(failedText);
			}
			this.save();

			return true;
		},

		save() {
			this.$emit('selected', this.files);
			this.$refs.input = '';
			this.closeDialog();
		},

		showDialog() {
			this.dialog = true;
		},
		closeDialog() {
			this.files = [];
			this.key++;
			this.dialog = false;
			this.$refs.input = '';
			this.$emit('closed');
		},
	}
}
</script>
